import React, { useState, useEffect, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './Header.css';
import FixedHeader from '../FixedHeader/FixedHeader';
import Weather from '../Weather/Weather';
import MonitoredIndividualUnitSearch from '../MonitoredIndividualUnitSearch/MonitoredIndividualUnitSearch';
import SelectedMI from '../SelectedMI/SelectedMI';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import viewport from '../../common/viewport';
import MobileMenu from '../MobileMenu/MobileMenu';
import mobileMenuLinks from '../../common/mobileMenuLinks';
import ImpersonateUser from '../ImpersonateUser/ImpersonateUser';
import logComponent from '../../common/logComponent';

export default function Header() {
  const environmentContext = useContext(EnvironmentContext);
  const [viewportIsSm, setViewportIsSm] = useState(viewport.isOldSm());
  const [monitoredIndividualSelectionVisible, setMonitoredIndividualSelectionVisible] = useState(false);
  const location = useLocation();
  const { pathname } = location;
  const { activeUser: user, organization, userModules, user: loggedInUser } = environmentContext;
  const dataLoaded = user && (organization || user.groupTypeString === 'Status Solutions');
  const showSelectedMonitoredIndividual = user.groupTypeString === 'Family' && !pathname.startsWith('/admin')
  const showMonitoredIndividualSearch = user.groupTypeString === 'Facility' && userModules && userModules.some(module => module.name === 'Individual/Unit Search')

  if (logComponent('Header')) { console.debug('Header render'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('Header')) { console.debug('Header onMount'); }
    window.addEventListener('resize', checkViewport);

    return function cleanup() {
      window.removeEventListener('resize', checkViewport);
    };
  }, []);

  const checkViewport = () => {
    if (logComponent('Header')) { console.debug('Header checkViewport'); }
    if (viewport.isOldSm() !== viewportIsSm) {
      setViewportIsSm(viewport.isOldSm());
    }
  }

  const toggleMonitoredIndividualSelectionVisibility = () => {
    if (logComponent('Header')) { console.debug('Header toggleMonitoredIndividualSelectionVisibility'); }
    setMonitoredIndividualSelectionVisible(!monitoredIndividualSelectionVisible)
  }

  return (
    <div className="Header">
      <FixedHeader>
        <div className={'Header__content' + ((showSelectedMonitoredIndividual || showMonitoredIndividualSearch) ? ' Header__content--no-border' : '')}>
          <div className="Header__text">
            <h1 className={'Header__facility-name' + (dataLoaded ? ' loaded' : '')}>
              {
                user && user.groupTypeString === 'Status Solutions' ?
                  'Status Solutions' :
                  organization ? organization.name : ''
              }
            </h1>
            <p className={'Header__portal-name' + (dataLoaded ? ' loaded' : '')}>{!dataLoaded ? '' :
              user.groupTypeString === 'Status Solutions' ? 'Status Solutions Portal' : user.groupTypeString === 'Corporate' ? 'Corporate Portal' :
                user.groupTypeString === 'Facility' ? 'Facility Portal' : 'Family Portal'}</p>
          </div>
          {
            loggedInUser.hasImpersonateViaGroupsOrOverride &&
            <ImpersonateUser />
          }
          <MobileMenu
            links={mobileMenuLinks} />
        </div>
      </FixedHeader>
      <div
        className={'Header__row-2' + ((showSelectedMonitoredIndividual || showMonitoredIndividualSearch) ? ' Header__row-2--show-small' : '')}
        style={monitoredIndividualSelectionVisible ? { zIndex: 20 } : {}}
      >
        {
          showMonitoredIndividualSearch &&
          <MonitoredIndividualUnitSearch />
        }
        {
          showSelectedMonitoredIndividual &&
          <SelectedMI
            onVisibilityChange={toggleMonitoredIndividualSelectionVisibility} />
        }
        <div className="Header__weather">
          {
            !viewportIsSm &&
            <Weather />
          }
        </div>
      </div>
      <div className={'Header__row-2-space-eater' + ((showSelectedMonitoredIndividual || showMonitoredIndividualSearch) ? ' Header__row-2-space-eater--show-small' : '')}></div>

    </div>
  );
}